export const  checkIsEqual = (a, b)=> {
  // null and "" are equal
  if ((a === null && b === "") || (a === "" && b === null)) return true;

  // Both are Dates
  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  // Mismatched types
  if (typeof a !== typeof b) return false;

  // Exact match for primitives
  if (a === b) return true;

  // Arrays
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    return a.every((item, i) => checkIsEqual(item, b[i]));
  }

  // Objects
  if (
    typeof a === "object" &&
    a !== null &&
    b !== null &&
    !Array.isArray(a) &&
    !Array.isArray(b)
  ) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every(key => checkIsEqual(a[key], b[key]));
  }

  return false;
};

export function formatDateForVerify(date = new Date()) {
  date = new Date(date);
  const pad = (n) => n.toString().padStart(2, "0");
  return `${pad(date.getMonth() + 1)}/${pad(
    date.getDate()
  )}/${date.getFullYear()}`;
}
